import React, { forwardRef } from 'react';
import { Box, Typography } from '@mui/material';
import { DS } from '../PatientForms/designTokens';
import { UnansweredField } from './formValidation';

export const UNANSWERED_QUESTIONS_ID = 'unanswered-questions';

interface UnansweredQuestionsProps {
  unanswered: UnansweredField[];
}

const UnansweredQuestions = forwardRef<
  HTMLDivElement,
  UnansweredQuestionsProps
>(({ unanswered }, ref) => (
  <Box
    ref={ref}
    id={UNANSWERED_QUESTIONS_ID}
    tabIndex={-1}
    role="alert"
    sx={{
      mx: -3,
      borderTop: '1px solid',
      borderBottom: '1px solid',
      borderColor: '#fcd34d',
      backgroundColor: '#fffbeb',
      px: 3,
      py: 2.5,
      color: '#111827',
    }}
  >
    <Typography
      sx={{
        fontSize: '18px',
        fontWeight: 600,
        color: '#92400e',
        mb: 1,
        fontFamily: DS.fontBody,
      }}
    >
      {unanswered.length > 5
        ? 'Du har inte svarat på alla frågor'
        : `Du har inte svarat på ${unanswered.length} ${unanswered.length === 1 ? 'fråga' : 'frågor'}`}
    </Typography>
    <Typography
      sx={{
        fontSize: '16px',
        color: '#b45309',
        mb: 1.5,
        fontFamily: DS.fontBody,
      }}
    >
      Det är viktigt att du fyller i alla svar så att läkaren får ett så bra
      underlag som möjligt.
    </Typography>
    <details style={{ fontSize: '16px', color: '#b45309' }}>
      <Box
        component="summary"
        sx={{
          cursor: 'pointer',
          textDecoration: 'underline',
          padding: '4px 0',
          listStyle: 'none',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          '&::marker': { content: '""' },
          '&::-webkit-details-marker': { display: 'none' },
          // drawn with borders rather than a glyph: the body font has
          // no disclosure triangle and renders tofu
          '&::before': {
            content: '""',
            width: 0,
            height: 0,
            flexShrink: 0,
            borderLeft: '5px solid currentColor',
            borderTop: '4px solid transparent',
            borderBottom: '4px solid transparent',
            transition: 'transform 150ms ease',
          },
          'details[open] > &::before': {
            transform: 'rotate(90deg)',
          },
        }}
      >
        Visa frågor som saknas
      </Box>
      <ul
        style={{
          marginTop: '8px',
          paddingLeft: '20px',
          listStyleType: 'disc',
        }}
      >
        {unanswered.map((field) => (
          <li key={field.anchorId} style={{ marginBottom: '6px' }}>
            <a
              href={`#${field.anchorId}`}
              onClick={(e) => {
                e.preventDefault();
                document.getElementById(field.anchorId)?.scrollIntoView({
                  behavior: 'smooth',
                  block: 'center',
                });
              }}
              style={{
                textDecoration: 'underline',
                padding: '4px 0',
                display: 'inline-block',
                color: 'inherit',
              }}
            >
              {field.label}
            </a>
          </li>
        ))}
      </ul>
    </details>
  </Box>
));

UnansweredQuestions.displayName = 'UnansweredQuestions';

export default UnansweredQuestions;
